import { typography } from 'src/common/styles/typography';
import styled, { css } from 'styled-components';
import { media } from 'src/common/styles/breakpoints';

// TODO: Import to VerificationReportForm
const SecondaryText = styled.p`
  color: ${({ theme }) => theme.text.secondary};
  font-size: 0.875rem;
  line-height: 1.1875rem;

  & > u {
    cursor: pointer;
  }
`;

const primaryTextCss = css`
  font-family: ${typography.fontFamilyDefault};
  color: ${({ theme }) => theme.text.primary};
  font-size: 1.125rem;
  line-height: 1.9375rem;
  text-align: left;
  font-weight: bold;
`;

export const Input = styled.input`
  ${media.w.max.px576(css`
    height: 1.75rem;
    padding: 0.75rem;
  `)}

  all: unset;
  width: calc(100% - 2rem);
  height: 2rem; // height for text only
  padding: 0.75rem 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.darkGrey};

  ${primaryTextCss};

  ::placeholder {
    ${primaryTextCss};
    opacity: 0.5;
  }

  &:invalid:not(:active):not(:focus) {
    color: ${({ theme }) => theme.colors.dangerBorder};
    background-color: ${({ theme }) => theme.colors.dangerSoft};
  }
`;

export const InputErrorText = styled(SecondaryText)`
  color: ${({ theme }) => theme.colors.dangerBorder};
  margin-bottom: 1rem;
`;
